import * as actionTypes from "./actionTypes";

const initialState = {
  polls: [],
  questions: [],
  answers: [],
  isLoading: false,
  locale: "es",
  dateFormat: "yyyy/mm/dd",
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_POLLS:
      return {
        ...state,
        isLoading: true,
        questions: [],
        answers: [],
      };
    case actionTypes.GET_POLLS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        polls: action.payload,
      };
    case actionTypes.GET_POLLS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_QUESTIONS:
      return {
        ...state,
        isLoading: true,
        questions: [],
        answers: [],
      };
    case actionTypes.GET_QUESTIONS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        questions: action.payload.questions,
      };
    case actionTypes.GET_QUESTIONS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_ANSWERS:
      return {
        ...state,
        isLoading: true,
        answers: [],
      };
    case actionTypes.GET_ANSWERS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        answers: action.payload.answers,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.GET_ANSWERS_REJECTED:
      return { ...state, isLoading: false };

    default:
      return state;
  }
}
